<div class="padding-content">
    <div class="btn-create m-0" (click)="openCreateMail()">
        <i class="fal fa-envelope"></i>
        <p class="m-0">Crear una comunicación para todos los asistentes a este evento</p>
    </div>
</div>